<template>
  <div class="seckill-template">
    <div class="detail-top-sec">
      <div class="sec-left">
        <div class="sec-price">
          <span>￥</span>
          <span>{{ detailInfo.price }}</span>
          <span>￥{{ detailInfo.oprice }}</span>
        </div>
        <div class="sec-title">
          <span class="sec-tag sec-tag-g">限时秒杀</span>
          <span class="sec-enname">Time-sensitive kill</span>
        </div>
      </div>
      <div class="sec-right" v-if="detailInfo.status == 1">
        <div class="sec-right-time">
          <span class="sec-time-title">距结束仅剩</span>
          <span class="sec-time-entitle">Ending in</span>
        </div>
        <div class="count-down-content" v-if="startStamp && startStamp">
          <count-down :startTime="startStamp" :endTime="endStamp" :secondsTxt="''"></count-down>
        </div>
        <!-- <van-count-down use-slot time="{{ time }}" bind:finish="finished" bind:change="onCountDown" format="HH:mm:ss">
          <span class="time-item">{{ timeData.hours }}</span>
          <span class="time-dot">:</span>
          <span class="time-item">{{ timeData.minutes }}</span>
          <span class="time-dot">:</span>
          <span class="time-item">{{ timeData.seconds }}</span>
        </van-count-down> -->
      </div>
      <div class="sec-time-box" v-if="detailInfo.status == 0">
        <span class="sec-time-title">{{ detailInfo.startTimeFormate }}</span>
        <span class="sec-time-entitle">限量开抢 Limited shot</span>
      </div>
    </div>
  </div>
</template>

<script>
import CountDown from "vue2-countdown";
import moment from "moment";
export default {
  name: "",
  data() {
    return {
      startStamp: null,
      endStamp: null,
    };
  },
  props: {
    detailInfo: {
      type: Object,
      default: () => {},
    },
  },
  computed: {},
  components: { CountDown },
  mounted() {},
  methods: {},
  watch: {
    detailInfo: {
      handler(val) {
        if (val) {
          this.endStamp = moment(val.endTime).valueOf();
          this.startStamp = moment(val.startTime).valueOf();
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style lang="scss">
.seckill-template {
  background: rgba(43, 43, 43, 1);
  .detail-top-sec {
    color: #fff;
    display: flex;
    justify-content: space-between;
    padding: 13px 20px;
    .sec-left {
      .sec-price {
        .sec-price-sym {
          font-size: 20px;
          color: #ffffff;
        }
        .sec-price-p {
          font-size: 20px;
          color: #ffffff;
          font-weight: bold;
        }
        .sec-price-op {
          font-size: 14px;
          font-weight: 500;
          text-decoration: line-through;
          color: #ffffff;
          margin-left: 8px;
        }
      }
      .sec-title {
        margin-top: 7px;
        .sec-enname {
          margin-left: 6px;
        }
      }
    }
    .sec-right {
      font-size: 16px;
      font-weight: 500;
      color: #ffffff;
      .sec-right-time {
        margin-bottom: 10px;
      }
      .count-down-content {
        text-align: right;
      }
      .sec-time-entitle {
        margin-left: 6px;
      }
    }
  }
}
</style>
